import styled, { css } from 'styled-components';

export const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    background-color: ${theme.v2.colors.neutral.highPure};
    border-left: 1px solid ${theme.v2.colors.neutral.highMedium};
    position: relative;
    overflow: hidden;
    border-top-right-radius: 24px;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      position: absolute;
      left: 0px;
      right: 0px;
    }
  `}
`;

export const Toolbar = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 20px;
    background-color: ${theme.v2.colors.neutral.highPure};
    border-bottom: 1px solid ${theme.v2.colors.neutral.highMedium};
    min-height: 58px;
    box-sizing: border-box;
  `}
`;

export const ToolbarButton = styled.button`
  ${({ theme, $hideInMobile }) => css`
    display: flex;
    align-items: center;
    background-color: ${theme.v2.colors.neutral.highPure};
    border-radius: 100%;
    border: 1px solid ${theme.v2.colors.neutral.highMedium};
    cursor: pointer;
    height: 36px;
    justify-content: center;
    width: 36px;

    ${$hideInMobile && css`
      @media (max-width: ${theme.v2.breakpoints.md}) {
        display: none;
      }
    `}
  `}
`;

export const ChatActions = styled.div`
  display: flex;
  gap: 16px;
`;

export const ContentArea = styled.div`
  background-color: ${({ theme }) => theme.v2.colors.neutral.highPure};
  display: flex;
  flex: 1;
  overflow: hidden;
  position: relative;
`;

export const Iframe = styled.iframe`
  ${({ theme, $isDesktopView }) => css`
    background-color: ${theme.v2.colors.neutral.highPure};
    border: none;
    height: 100%;
    margin: 0px auto;
    transform-origin: top left;
    transition: transform 0.2s ease-in-out, width 0.2s ease-in-out;
    width: ${$isDesktopView ? '100%' : '347px'};
  `}
`;

export const ToggleViewWrapper = styled.div`
  ${({ theme }) => css`
    border-radius: 1000px;
    border: 1px solid ${theme.v2.colors.neutral.highMedium};
    display: flex;
    flex-direction: row;
    margin: 0 auto;
    padding: 4px;

    @media min-width: ${theme.v2.breakpoints.md} {
      display: none;
    }
  `}
`;

export const ToggleView = styled.button`
  ${({ theme, $active }) => css`
    align-items: center;
    background-color: ${theme.v2.colors.neutral.highPure};
    border-radius: 1000px;
    border: none;
    color: ${theme.v2.colors.neutral.lowDark};
    cursor: pointer;
    display: flex;
    justify-content: center;
    padding: 6px 14px;
    transition: 250ms;

    ${$active && css`
      background-color: ${theme.v2.colors.brand.primaryLowLight};
    `}
  `}
`;

export const ContainerSkeletonRow = styled.div`
  ${({ $isDesktopView }) => css`
    display: flex;
    flex-direction: column;
    margin: 0px auto;
    width: ${$isDesktopView ? '100%' : '348px'};
    padding: 16px 26px;
    transition: width 0.2s ease-in-out;
  `}
`;

export const HeaderSkeletonRow = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 19px;

  div:last-child {
      margin-left: auto;
  }
`;

export const HeroSkeletonRow = styled.div`
  margin-top: 29px;
`;

export const CardsWrapperSkeleton = styled.div`
  display: flex;
  flex-direction: row;
  gap: 22px;
  margin-top: 32px;
  overflow: hidden;
`;

export const CardSkeleton = styled.div`
  ${({ $hide, $full }) => css`
    display: ${$hide ? 'none' : 'flex'};
    flex-direction: column;
    gap: 8px;
    min-width: ${$full ? '100%' : '236px'};
  `}
`;

export const SecondHeaderSkeletonRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 70px;
  margin-top: 64px;
`;

export const RectangleSkeletonWrapper = styled.div`
  margin-top: 32px;
`;
